import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService.js';
import { wsGetAll } from 'services/WService';
import moment from 'moment';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [coverages, setCoverages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isRequired, setIsRequired] = useState(true);
  
  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listCoverage() {
    let response = await wsGetAll('sale/cobertura-colgate');
    if (response.success) setCoverages(response.data);
  }

  async function listCategories() {
    let response = await wsFindBy('logi/category', { state: 'A', deleted_at: 'null', base_business_partner_id: 7 });
    if (response.success) setCategories(response.data);
  }

  useEffect(() => {
      if (customerPortfolioB.open) {
        if (!customerPortfolioB.id) listCoverage();
        listCategories();
        setDataChanging(customerPortfolioB);
      }
    }, [customerPortfolioB.open]);

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setDataChanging((prev) => ({
        ...prev,
        logi_category_id: null,
      }));
      setIsRequired(false);
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => ({
          logi_category_id: item.CODIGOCATEGORIA,
          cuota: item.CUOTA,
          description: item.DESCRIPCION,
        })),
        logi_category_id: dataImport.nameFile,
      });
    } else if (dataImport?.success === false) {
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  const handleAutocompleteChange = (field, value) => {
    handleChange(field, value?.id || null);
  
    if (field === 'logi_category_id') {
      setDataImport(null);
    }
    setIsRequired(true);
  };

    useEffect(() => {
      if (bPartnerSelect?.id) {
        setDataImport({});
      }
    }, [bPartnerSelect]);

  return (
    <>
      <Modal
        title={`Nueva cuota de categorias`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.logi_category_id
            ? 'sale/cuota-categoria-colgate'
            : 'sale/cuota-categoria-colgate/multiple'
        }
        dataForce={
          dataChanging.logi_category_id
            ? {
                id_cobertura: dataChanging.id_cobertura,
                logi_category_id: dataChanging.logi_category_id,
                cuota: dataChanging.cuota,
                description: dataChanging.description,
              }
            : {
                id_cobertura: dataChanging.id_cobertura,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
      <Autocomplete
        options={coverages}
        getOptionLabel={(item) => item.description}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Coberturas bimestrales"
            margin="normal"
            required={isRequired}
          />
        )}
        required
        onChange={(e, item) => {handleChange('id_cobertura', item?.id); setDataImport(null);}}
        value={coverages.find((coverage) => coverage.id === dataChanging.id_cobertura) || null}
      />
      <span style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Autocomplete
          options={categories}
          getOptionLabel={(item) => item.description}
          renderInput={(params) => (
            <TextField {...params} label="Categorías" margin="normal" required={isRequired} />
          )}
          onChange={(e, item) => {
            handleAutocompleteChange('logi_category_id', item);
          }}
          value={
            categories.find((categoria) => categoria.id === dataChanging.logi_category_id) || null
          }
          fullWidth
        />
        <ImportExcel
          setDataImport={setDataImport}
          btnColor="success"
          validDuplicate="CODIGOCATEGORIA"
          sortDuplicate="CODIGOCATEGORIA"
          downTemplate={{
            fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de datos de cobertura de Categoria`,
            fields: ['CODIGOCATEGORIA','CUOTA','DESCRIPCION']
          }}
        />
        </span>
        {dataImport?.success && !dataChanging.logi_category_id && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.logi_category_id ? (
        <>
          <TextField
            label="Cuota"
            type="number"
            margin="normal"
            name="cuota"
            value={dataChanging.cuota || ''} 
            onChange={(e) => handleChange('cuota', e.target.value)}
            required
            fullWidth
          />
          <TextField
            label="Descripción de la categoría"
            type="text"
            margin="normal"
            name="description"
            value={dataChanging.description || ''}
            onChange={(e) => handleChange('description', e.target.value)}
            required
            fullWidth
          />
        </>
      ) : undefined}
      </Modal>
    </>
  );
});
